export default "__VITE_ASSET__BGKhH6J5__"